module.exports = __webpack_public_path__ + "media/apps/play_store_button-c5a5b9f5.png";